import { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { useAuth } from '../../../context/AuthContext';
import { liveVisitSession } from '../../../visitSession';

const DigitalClock = ({ userMenu = false }) => {
    const { visitSession, activeSessionCounter } = useAuth();
    const [, setTick] = useState(0);

    useEffect(() => {
        if (!visitSession) {
            return undefined;
        }
        const id = setInterval(() => setTick((value) => value + 1), 1000);
        return () => clearInterval(id);
    }, [visitSession]);

    const live = liveVisitSession(visitSession);

    return (
        <Box
            sx={{
                color: live?.style.barColor || 'rgba(255, 255, 255, 0.75)',
                bgcolor: live?.style.barBg || 'transparent',
                textAlign: 'right',
                display: 'flex',
                alignItems: userMenu ? 'flex-start' : 'flex-end',
                px: userMenu ? 0 : 1.5,
                flexDirection: 'column',
                justifyContent: 'center',
                height: '100%',
                minWidth: { md: 168 },
                maxWidth: 240,
            }}
        >
            <Box sx={{ fontSize: '12px', fontWeight: 700, letterSpacing: 0.4 }}>
                {live ? live.label : 'Active Session'}
            </Box>
            <Box sx={{ fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                {live
                    ? `${live.clock}${live.patientName ? ` · ${live.patientName}` : ''}`
                    : activeSessionCounter}
            </Box>
        </Box>
    );
};

export default DigitalClock;
